module.exports = __webpack_public_path__ + "static/media/hamburger-menu-icon-black.14f6a91a.svg";